import {
  Component,
  Input,
  ViewContainerRef,
  ViewChild,
  AfterViewInit,
  OnDestroy,
  Output,
  EventEmitter,
  createComponent,
  inject,
  ApplicationRef
} from "@angular/core";
import { Subscription } from "rxjs";
import { ReportDesignerItemCustom } from "../../report-design-item";
import { ReportDesignerCustomComponentInstance } from "../report-designer-custom-component-instance";

@Component({
  selector: "snt-report-designer-custom",
  templateUrl: "report-designer-custom.component.html",
  styles: [
    `
      :host {
        display: flex;
        flex: 1;
      }
    `
  ],
  standalone: false
})
export class ReportDesignerCustomComponent implements AfterViewInit, OnDestroy {
  @Input() item!: ReportDesignerItemCustom;

  @Output() config: EventEmitter<any> = new EventEmitter();

  @ViewChild("container", { read: ViewContainerRef })
  containerRef!: ViewContainerRef;

  componentInstance!: ReportDesignerCustomComponentInstance;

  private dataSubscription: Subscription | undefined;

  constructor() {}

  private readonly applicationRef = inject(ApplicationRef);

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.containerRef.clear();

      const componentRef = createComponent(this.item.component, {
        environmentInjector: this.applicationRef.injector,
        hostElement: this.containerRef.element.nativeElement!
      });

      this.componentInstance = <ReportDesignerCustomComponentInstance>(
        componentRef.instance
      );

      this.componentInstance.item = this.item;

      componentRef.changeDetectorRef.detectChanges();

      this.dataSubscription = this.componentInstance.data$.subscribe((data) => {
        this.config.emit(data);
      });
    }, 0);
  }

  ngOnDestroy(): void {
    this.dataSubscription?.unsubscribe();
  }
}
